import state from './moduleCrewLaborState.js'
import mutations from './moduleCrewLaborMutations.js'
import actions from './moduleCrewLaborActions.js'
import getters from './moduleCrewLaborGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
